import React, { Component } from 'react';
import AuthNavbar from '../navigation/authnavigation.jsx'
import LeftLink from '../leftlink/leftlink.jsx'
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import creditcardlogo from "../../images/credit-cards-vector-icon-.jpg";
import frequencyimg from '../../images/frequency.png'
import { ToastContainer, toast } from 'react-toastify';
import '../../stylesheet/transfer.css'
import {
    Link
} from 'react-router-dom';
import Loader from '../loader/loader.jsx'
import 'react-toastify/dist/ReactToastify.css';

import * as actions from '../../actions/actions.jsx'
import { connect } from "react-redux";
// import Loader from '../loader/loader.jsx'
import s from '../../services/allservices.jsx'

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },

    focusTextStyle: {
        color: "#333"
    },


};




const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        keyRecieved: state.publicKey.keyRecieved,
        cardState: state.getCardReducer.cardState,
        display: state.getCardReducer.display,
        profileState: state.getProfileReducer.profileState,
        friendsState: state.getFriendsReducer.friendsState
    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPublicKey(keyRecieved) {
            dispatch(
                actions.publicKeyAction(keyRecieved)
            )
        },
        fetchCard(state) {
            dispatch(
                actions.getCardAction(state)
            )
        },
        fetchFriends() {
            dispatch(
                actions.getFriendsAction()
            )
        }
    })
const JSEncrypt = window.JSEncrypt
class ShareFunds extends Component {
    state = {
        toAccount: 1,
        fromAccount: 1,
        transferFrequency: 1,
        amount: "",
        expDate: "",
        firstName: "",
        lastName: "",
        comment: "",
        disabled: true,
        loader: true,
        correctcomment: true,
        commentState: true,
        required: PropTypes.bool,
        amountState: true,
        correctamount: true,

    }
    componentDidMount() {
        this.setState({
            loader: true
        })
        const { publicKey } = this.props
        let _this = this
        setTimeout(function () {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);


                const state = {
                    applicationId: "gmcabs",
                    accountId: encrypt.encrypt(localStorage.getItem("accountId"))
                }

                _this.props.fetchCard(state)
                _this.props.fetchFriends();
            }
        }, 1000);
        this.setState({
            loader: false,
        })
    }
    removeamount = () => {
        this.setState({
            amountState: true
        })
    }

    onChangeamount = (e, value) => {
        if (e.target.name === "amount") {
            if (/^\d+(\.\d{1,2})?$/.test(e.target.value)) {
                this.setState({
                    correctamount: true,
                    amount: value,
                })
            } else {
                this.setState({
                    correctamount: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    onChangecomment = (e, value) => {
        if (e.target.name === "comment") {
            if (/^[a-zA-Z]$/.test(e.target.value)) {
                this.setState({
                    correctcomment: true,
                    comment: value,
                })
            } else {
                this.setState({
                    correctcomment: false
                })
            }
        } else {
            this.setState({
                [e.target.name]: e.target.value
            })
        }

    }
    removecoment = () => {
        this.setState({
            commentState: true
        })
    }
    decimal = (amount) => {              
            var value = Number(amount);
            if (String(amount).split(".").length < 2 || String(amount).split(".")[1].length<=2 ){
                amount = amount.toFixed(2);
            }
         return amount;
           
    }
   
    onChange = (e, value) => {

        if (e.target.name === "comment") {

            
            if (e.target.name === "comment") {
                if (/^[a-zA-Z]$/.test(e.target.value)) {
                    this.setState({
                        correctcomment: true,
                        comment: value,
                    })
                } else {
                    this.setState({
                        correctcomment: false
                    })
                }
            }

            this.setState({
                [e.target.name]: e.target.value
            }, () => {

                const { amount, comment } = this.state
               
                if (amount !== "" && comment !== "") {

                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
        }

    }


    handleSelect1 = (event, index, value) => {
        this.setState({ fromAccount: value });
    }
    handleSelect2 = (event, index, value) => {
        this.setState({ toAccount: value });
    }
    handleSelect3 = (event, index, value) => {
        this.setState({ transferFrequency: value });
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            loader: true
        })
        try {
            if (nextProps.cardState && nextProps.cardState.length !== 0) {
                this.setState({
                    loader: false,
                    fromAccount: nextProps.cardState.body[0].cardDetailsId
                })
            }
            if (nextProps.friendsState && nextProps.friendsState.length !== 0) {
                this.setState({
                    loader: false,
                    toAccount: nextProps.friendsState.body[0].cardDetailsId
                })
            }
        } catch (e) {

        }
    }
    handleFriends() {
        this.props.history.push("/friends&family")
    }
    handleSubmit = () => {
        const { fromAccount, amount, commentState, toAccount, correctamount, correctcomment } = this.state
        if (amount === "") {
            this.setState({
                amountState: false,
            })
        }
        else if (correctamount === false) {
            this.setState({
                correctamount: false,
            })
        }


        else if (this.state.comment === "") {
            this.setState({
                commentState: false,
            })
        }
        else {
            const { friendsState } = this.props
            let firstName, lastName
            try {
                for (let i = 0; i <= friendsState.body.length; i++) {
                    if (friendsState.body[i].cardDetailsId === this.state.toAccount) {
                        firstName = friendsState.body[i].firstName
                        lastName = friendsState.body[i].lastName
                    }
                }
            } catch (e) {

            }

            const { publicKey } = this.props
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);
                let state = {
                    amount: encrypt.encrypt(this.state.amount),
                    applicationId: "gmcabs",
                    firstName: encrypt.encrypt(firstName),
                    fromCardDetailsId: encrypt.encrypt(this.state.fromAccount),
                    lastName: encrypt.encrypt(lastName),
                    toCardDetailsId: encrypt.encrypt(this.state.toAccount),
                    comments: encrypt.encrypt(this.state.comment)
                }
                let _this = this
                let token = "Token " + localStorage.getItem('token')
                if (this.state.toAccount !== this.state.fromAccount) {
                    fetch(s.share_fund + "/?Authorization=" + token, {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                        }),
                        body: JSON.stringify(state)
                    })
                        .then(response => {
                            if (response.status === 200 || response.status === 201 || response.status === 204) {
                                toast.success(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });

                                setTimeout(function () { window.location.reload(true); }, 1000);

                            } else {
                                toast.error(response.headers.get('message'), {
                                    position: "top-right",
                                    draggablePercent: 60,
                                    autoClose: 3000,
                                    hideProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                });


                            }
                        })
                } else {
                    toast.error("You cant transfer funds to same card account", {
                        position: "top-right",
                        draggablePercent: 60,
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    });
                }
            }
        }
    }
    render() {
        const { cardState, friendsState } = this.props
        const { fromAccount, toAccount, amountState, correctamount, commentState, correctcomment } = this.state
        return (
            <div>
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div className="row">
                    <div className="col-sm-12">
                        <AuthNavbar />
                    </div>

                </div>
                <div className="container" style={{ marginTop: "80px" }}>
                    <div className="row">
                        <div className="col-sm-3 box-shadow-style nopadding" style={{ minHeight: "470px" }}>
                            <LeftLink />
                        </div>

                        <div className="col-sm-9" style={{ padding: "0px 30px" }}>

                            <div className="row box-shadow-style" style={{ padding: "12px 0px", minHeight: "476px" }}>
                                <div className="col-sm-12">
                                    <div className="header-style">
                                        <h4>
                                            Share Funds
                            </h4>
                                        <p>
                                            Transfer funds from one account to another by filling in the Transfer Detail fields shown below. The amount entered in the Transfer Detail will be automatically transferred to the account selected when you click Transfer. Fields marked with * must be filled.
                            </p>
                                    </div>

                                </div>
                                <div className="col-sm-12">
                                    {cardState.status === 200 && friendsState.status === 200 ?

                                        <div className="nopadding">
                                            {(friendsState.body.length !== 0) ?
                                                <div className="nopadding">
                                                    <div className="transfer-detail-header">
                                                        <h5>Transfer Details</h5>
                                                    </div>
                                                    <div className="transfer-detail-body">

                                                        <div className="row input-group" >
                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-2 input-icon" >
                                                                        <img src={creditcardlogo} alt="" />
                                                                    </div>
                                                                    <div className="col-sm-10" >
                                                                        {cardState.status === 200 && cardState.body.length !== 0 &&
                                                                            <SelectField
                                                                                floatingLabelText="Card Account (From) "
                                                                                onChange={this.handleSelect1}
                                                                                className="required"
                                                                                name="fromAccount"

                                                                                value={fromAccount}

                                                                            >
                                                                                {cardState.body.map((value, i) =>
                                                                                    <MenuItem value={cardState.body[i].cardDetailsId} primaryText={cardState.body[i].cardNumber} key={i} />
                                                                                )}


                                                                            </SelectField>}
                                                                    </div>
                                                                </div>

                                                            </div>

                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-2 input-icon" >
                                                                        <img src={creditcardlogo} alt="" />
                                                                    </div>
                                                                    <div className="col-sm-10" >
                                                                        {friendsState.status === 200 && friendsState.body.length !== 0 &&
                                                                            <SelectField
                                                                                required
                                                                                floatingLabelText="Card Account (To)  "
                                                                                onChange={this.handleSelect2}
                                                                                
                                                                                className="required"
                                                                                name="toAccount"
                                                                                value={toAccount}

                                                                            >
                                                                                {friendsState.body.map((value, i) =>
                                                                                    <MenuItem value={friendsState.body[i].cardDetailsId} primaryText={friendsState.body[i].cardNumber} key={i} />
                                                                                )}
                                                                            </SelectField>

                                                                        }
                                                                    </div>

                                                                </div>

                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-2 sharefund" style={{ left: "2px" }}>
                                                                        <i className="fa fa-usd" aria-hidden="true"></i>
                                                                    </div>
                                                                    <div className="col-sm-10 " >

                                                                        <TextField
                                                                            required
                                                                            floatingLabelText="amount"
                                                                            type="text"
                                                                            name="amount"
                                                                            className="required"
                                                                            maxLength="10"
                                                                            onFocus={this.removeamount}
                                                                            onChange={this.onChangeamount}
                                                                            step="0.01"
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            errorText={amountState ? correctamount ? null : "Not a valid amount" : "This field is required"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-sm-6">
                                                <div className="row">
                                                    <div className="col-sm-2 input-icon" >
                                                        <img src={frequencyimg} alt="F" />
                                                    </div>
                                                    <div className="col-sm-10" >
                                                        <SelectField
                                                            floatingLabelText="Transfer Frequency "
                                                            onChange={this.handleSelect3}
                                                            className="input-width"
                                                            name="transferFrequency"
                                                            value={this.state.transferFrequency}
                                                        >
                                                            <MenuItem value={1} primaryText="One Time, Right Now" />
                                                            <MenuItem value={2} primaryText="One Time, On Specific Date" />
                                                            <MenuItem value={3} primaryText="Weekly" />
                                                            <MenuItem value={4} primaryText="Every Two Weeks" />
                                                            <MenuItem value={5} primaryText="Monthly" />
                                                            <MenuItem value={6} primaryText="Every Three Months" />
                                                            <MenuItem value={7} primaryText="Every Six Months" />
                                                            <MenuItem value={8} primaryText="Yearly" />
                                                        </SelectField>
                                                    </div>
                                                </div>

                                            </div> */}
                                                            <div className="col-sm-6">
                                                                <div className="row">
                                                                    <div className="col-sm-2 input-icon" style={{ left: "2px" }}>
                                                                        <i className="fa fa-comment text-dark " aria-hidden="true"></i>
                                                                    </div>
                                                                    <div className="col-sm-10" >
                                                                        <TextField
                                                                            hintText="Write Your Comment"
                                                                            floatingLabelText="Comments"
                                                                            multiLine={true}
                                                                            className="input-width required"
                                                                            maxLength="60"
                                                                            name="comment"
                                                                            onChange={this.onChange}
                                                                            onFocus={this.removecoment}
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            errorText={commentState ? null : "This field is required"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6" style={{ marginTop: "50px" }}>
                                                                <RaisedButton
                                                                    label="Transfer Now"
                                                                    disabled={this.state.disabled}
                                                                    className="pull-right"
                                                                    // style={styles.button}
                                                                    backgroundColor="#333"
                                                                    labelColor="#fff"
                                                                    onClick={this.handleSubmit}
                                                                // icon={<i className="fa fa-search" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                <div className="nopadding" style={{ marginTop: "-140px" }}>
                                                    <div className="transfer-detail-header">
                                                        <h5>Transfer Details</h5>
                                                    </div>
                                                    <div className="col-sm-12 transfer-detail-body" style={{ marginTop: "15px", marginLeft: "65px" }}>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <span style={{ fontSize: "19px" }} >
                                                                    To transfer funds you need one additional card account
                                                             </span>
                                                            </div>
                                                            <div className="col-sm-12" style={{ marginLeft: "150px", marginTop: "20px" }}>

                                                                <RaisedButton
                                                                    label="Add Card Account"
                                                                    className=""

                                                                    // style={styles.button}
                                                                    backgroundColor="#333"
                                                                    labelColor="#fff"
                                                                    onClick={this.handleFriends.bind(this)}
                                                                // icon={<i className="fa fa-search" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                />

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            }

                                        </div>

                                        : <Loader />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ShareFunds.defaultProps = {
    cardState: {
        status: 600
    },
    friendsState: {
        status: 600
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareFunds);


// WEBPACK FOOTER //
// ./src/components/transferfunds/sharefunds.jsx